import { render } from "./AccountMobile.vue?vue&type=template&id=5facec45"
import script from "./AccountMobile.vue?vue&type=script&lang=js"
export * from "./AccountMobile.vue?vue&type=script&lang=js"

import exportComponent from "/Users/trifjolngjela/Projects/home-budget/home-budget-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__